import * as React from 'react';

const useHashNavigation = ()=>{
    const [hash, setHash] = React.useState(()=>{
        if (typeof window === 'undefined') {
            return '';
        }
        return window.location.hash;
    });
    React.useEffect(()=>{
        if (typeof window === 'undefined') {
            return;
        }
        const onHashChange = ()=>{
            setHash(window.location.hash);
        };
        window.addEventListener('hashchange', onHashChange);
        return ()=>window.removeEventListener('hashchange', onHashChange)
        ;
    }, []);
    const clearHash = React.useCallback(()=>{
        window.location.hash = '';
    }, []);
    return {
        hash,
        clearHash
    };
};

export { useHashNavigation };
//# sourceMappingURL=use-hash-navigation.js.map
